import React from 'react'
import { FaSearch } from 'react-icons/fa'

const Search = () => {
  return (
    <div className='search'>
        <FaSearch className='search-icon' />
    </div>
  )
}

export default Search